const state = () => ({
  searchKey: null,
  distance: null,
  center: null,
});

const actions = {};

const mutations = {
  setSearchKey (state, searchKey) {
    state.searchKey = searchKey;
  },
  setDistance (state, distance) {
    state.distance = distance;
  },
  setCenter (state, center) {
    state.center = center;
  },
};

const getters = {
  getSearchKey (state) {
    return state.searchKey;
  },
  getDistance (state) {
    return state.distance;
  },
  getCenter (state) {
    return state.center;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
